import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Avatar, Box, ButtonBase, Typography } from '@mui/material';
import { IconChevronRight } from '@tabler/icons-react';

const MenuCard = () => {
  const user = useSelector((state) => state.account.user);
  return (
    <ButtonBase
      component={Link}
      to="/panel/profile"
      aria-label="查看账户设置"
      sx={{
        width: '100%',
        display: 'flex',
        textAlign: 'left',
        gap: 1.5,
        p: 1.5,
        my: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        '&:hover': { bgcolor: 'action.hover' }
      }}
    >
      <Avatar sx={{ width: 32, height: 32, bgcolor: 'action.selected', color: 'text.primary', fontSize: 14 }}>
        {(user?.username || 'V').slice(0, 1).toUpperCase()}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography noWrap sx={{ color: 'text.primary', fontWeight: 600, fontSize: 13 }}>
          {user?.username || '账户'}
        </Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 11, mt: 0.25 }}>
          {user?.role >= 100 ? '管理员工作台' : '个人工作台'}
        </Typography>
      </Box>
      <IconChevronRight size={16} aria-hidden="true" />
    </ButtonBase>
  );
};
export default MenuCard;
